module.exports = __webpack_public_path__ + "img/icon0.6475c229.png";